<script setup>
// import brand_block_1_h from "@/assets/lottie/brand-block/brand_block_1_h.json";
// import brand_block_1_v from "@/assets/lottie/brand-block/brand_block_1_v.json";
// import brand_block_2_h from "@/assets/lottie/brand-block/brand_block_2_h.json";
// import brand_block_2_v from "@/assets/lottie/brand-block/brand_block_2_v.json";
// import brand_block_3_h from "@/assets/lottie/brand-block/brand_block_3_h.json";
// import brand_block_3_v from "@/assets/lottie/brand-block/brand_block_3_v.json";
// import brand_block_4_h from "@/assets/lottie/brand-block/brand_block_4_h.json";
// import brand_block_4_v from "@/assets/lottie/brand-block/brand_block_4_v.json";
// import brand_block_5_h from "@/assets/lottie/brand-block/brand_block_5_h.json";
// import brand_block_5_v from "@/assets/lottie/brand-block/brand_block_5_v.json";
// import brand_block_6_h from "@/assets/lottie/brand-block/brand_block_6_h.json";
// import brand_block_6_v from "@/assets/lottie/brand-block/brand_block_6_v.json";

import { Swiper, SwiperSlide } from "swiper/vue";
import { FreeMode } from "swiper/modules";
import "swiper/css";

import { highlightText } from "@/lib/utils.js";

// const brandBlockList = [
//     {
//         mobile: brand_block_1_h,
//         desktop: brand_block_1_v,
//     },
//     {
//         mobile: brand_block_2_h,
//         desktop: brand_block_2_v,
//     },
//     {
//         mobile: brand_block_3_h,
//         desktop: brand_block_3_v,
//     },
//     {
//         mobile: brand_block_4_h,
//         desktop: brand_block_4_v,
//     },
//     {
//         mobile: brand_block_5_h,
//         desktop: brand_block_5_v,
//     },
//     {
//         mobile: brand_block_6_h,
//         desktop: brand_block_6_v,
//     },
// ];

const emit = defineEmits(["loadMore"]);

const props = defineProps({
    title: {
        type: Array,
    },
    isScroll: {
        type: Boolean,
        default: true,
    },
    videos: {
        type: Array,
    },
    isLoading: {
        type: Boolean,
        default: false,
    },
    showLoadMore: {
        type: Boolean,
        default: false,
    },
    hasMore: {
        type: Boolean,
        default: true,
    },
    highlightKeyword: {
        type: String,
        default: "",
    },
});

const { width } = useWindowSize();
const nuxtApp = useNuxtApp();

// 輪播
const videoSwiper = ref(null);
const activeIndex = ref(0);
const isOpen = ref(false);

const shortMedia = computed(() => {
    return nuxtApp?.payload?.data?.["fetchMedias-short-media"];
});

const swiperInit = (swiper) => (videoSwiper.value = swiper);
const swiperSlideChange = (swiper) => (activeIndex.value = swiper.realIndex);
const slideToNext = () => {
    if (width.value >= 1270) videoSwiper.value.slideNext();
};
const slideToPrev = () => {
    if (width.value >= 1270) videoSwiper.value.slidePrev();
};

// 插入 brand block
// const isShowSloganArray = reactive(Array(props.videos?.length || 0).fill(-1));

// const shouldShowSlogan = (index) => {
//     if (props.isScroll) return false;

//     if (width.value >= 1024) return (index + 1) % 6 === 0;
//     else if (width.value >= 640) return (index + 1) % 4 === 0;
//     else return (index + 1) % 6 === 0;
// };
// const updateSloganArray = () => {
//     if (!props.videos || props.videos.length === 0) return;

//     let counter = 0;
//     for (let i = 0; i < props.videos.length; i++) {
//         isShowSloganArray[i] = -1;
//         if (shouldShowSlogan(i)) {
//             isShowSloganArray[i] = counter;
//             counter++;
//         }
//     }
// };

// watch(
//     width,
//     () => {
//         if (props.isScroll) return;
//         updateSloganArray();
//     },
//     { immediate: true },
// );
// watch(
//     () => props.videos,
//     (newVideos) => {
//         if (newVideos && newVideos.length > 0 && !props.isScroll) {
//             while (isShowSloganArray.length < newVideos.length) {
//                 isShowSloganArray.push(-1);
//             }
//             if (isShowSloganArray.length > newVideos.length) {
//                 isShowSloganArray.splice(newVideos.length);
//             }
//             updateSloganArray();
//         }
//     },
//     { immediate: true, deep: true },
// );

// 追蹤影片載入狀態
const loaderRef = ref(null);
const observer = ref(null);
const videoLoadState = ref({});

// 載入影片
const loadVideo = (id) => {
    videoLoadState.value[id] = true;

    // 延遲執行，確保DOM已更新
    setTimeout(() => {
        const videoElement = document.querySelector(`[data-video-id="${id}"]`);
        if (videoElement) {
            // 顯示影片
            videoElement.style.opacity = "1";
            videoElement.play();
        }
    }, 100);
};

const loadMore = () => {
    if (!props.isLoading && props.hasMore) {
        emit("loadMore");
    }
};

// 滑鼠離開暫停影片
const pauseVideo = (id) => {
    const videoElement = document.querySelector(`[data-video-id="${id}"]`);
    if (videoElement) {
        videoElement.pause();
        // 逐漸隱藏影片
        videoElement.style.opacity = "0";

        // 300毫秒後將影片載入狀態重置
        setTimeout(() => {
            videoLoadState.value[id] = false;
        }, 300);
    }
};

const handleOpenVideo = (id) => {
    isOpen.value = true;
    if (!isOpen.value) loadVideo(id);
};

onMounted(() => {
    if (!props.isScroll) {
        // updateSloganArray();

        // 設置 Intersection Observer 來監測底部加載器元素
        if (props.showLoadMore) {
            observer.value = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting) {
                        loadMore();
                    }
                },
                { threshold: 0.5 },
            );

            // 開始觀察
            if (loaderRef.value) {
                observer.value.observe(loaderRef.value);
            }
        }
    }
});

onBeforeUnmount(() => {
    // 清理 Observer
    if (observer.value && loaderRef.value) {
        observer.value.unobserve(loaderRef.value);
        observer.value = null;
    }
});
</script>

<template>
    <div class="slt-video-list gap-[4.07vw] xs:gap-[16px] sm:gap-[24px]">
        <h2
            class="slt-h3-ttd pl-[4.07vw] text-base-white xs:pl-[16px] sm:pl-[5.21vw] lg:pl-[6.61vw] 3xl:pl-[127px]"
        >
            <span v-for="(text, index) in title" :key="text"
                ><br v-if="index > 0" />{{ text }}</span
            >
        </h2>
        <div v-if="isScroll" class="video-list-container">
            <div
                v-if="videos.length > 4"
                class="slt-dark-slider-mask"
                @click="slideToPrev"
            >
                <img
                    class="absolute top-[50%] w-[40px] -translate-y-1/2 scale-x-[0.5] scale-y-[2]"
                    src="@/assets/images/pages/gplay/swipe-arrow.png"
                    alt=""
                />
            </div>
            <div class="video-list-wrapper">
                <div
                    class="mx-[4.07vw] pb-[10vw] xs:mx-[16px] sm:mx-[5.21vw] sm:pb-0 lg:mx-[5.95vw] 3xl:mx-[114.3px]"
                >
                    <Swiper
                        :slidesPerView="
                            width >= 1270 ? 4 : width >= 640 ? 3 : 1.5
                        "
                        :spaceBetween="24"
                        :freeMode="true"
                        :modules="[FreeMode]"
                        @swiper="swiperInit"
                        @slideChange="swiperSlideChange"
                        :style="{ overflow: 'visible' }"
                    >
                        <SwiperSlide v-for="(video, i) in videos" :key="i">
                            <NuxtLink
                                :to="$localePath(`/gplay/${video.id}`)"
                                class="slt-video-item flex w-full flex-col"
                                @mouseenter="loadVideo(`scroll-${i}`)"
                                @mouseleave="pauseVideo(`scroll-${i}`)"
                                @click="handleOpenVideo(`scroll-${i}`)"
                                v-sendGAsignal="{
                                    event_category: 'gplay',
                                    event_label: `${video?.id}-${video?.videoTitle}`,
                                }"
                            >
                                <div
                                    class="relative aspect-[310/408] w-full overflow-hidden rounded-[4.07vw] xs:rounded-[16px]"
                                >
                                    <img
                                        class="relative h-full w-full object-cover object-center"
                                        :src="
                                            shortMedia?.find(
                                                (item) =>
                                                    item?.id ==
                                                    video?.featured_media,
                                            )?.source_url
                                        "
                                        :alt="
                                            shortMedia?.find(
                                                (item) =>
                                                    item?.id ==
                                                    video?.featured_media,
                                            )?.alt_text
                                        "
                                        width="310"
                                        height="408"
                                    />
                                    <video
                                        v-if="
                                            videoLoadState[`scroll-${i}`] &&
                                            !isOpen
                                        "
                                        class="absolute left-0 top-0 z-10 h-full w-full object-cover object-center opacity-0 transition-opacity duration-300"
                                        :src="video.preview[0]"
                                        muted
                                        loop
                                        width="310"
                                        height="408"
                                        :data-video-id="`scroll-${i}`"
                                    ></video>
                                </div>
                                <div class="flex flex-col px-[8px]">
                                    <h3
                                        class="slt-line-clamp-2 slt-h5-d mt-[3.05vw] text-base-white xs:mt-[12px] sm:mt-[1.56vw] lg:mt-3"
                                        v-html="
                                            highlightText(
                                                video.title,
                                                highlightKeyword,
                                            )
                                        "
                                    ></h3>
                                    <p
                                        class="slt-line-clamp-2 slt-body-3-d mt-[4px] font-bold text-base-grey sm:font-normal"
                                        v-html="
                                            highlightText(
                                                video.description,
                                                highlightKeyword,
                                            )
                                        "
                                    ></p>
                                    <div
                                        class="mt-[4.07vw] flex flex-wrap gap-[4px] xs:mt-[16px] sm:mt-[2.6vw] lg:mt-5"
                                    >
                                        <div
                                            v-for="(tag, k) in video.categories"
                                            :key="k"
                                            class="slt-hashtag slt-body-3 text-base-white"
                                        >
                                            <p>
                                                {{ tag }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </NuxtLink>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>
            <div
                v-if="videos.length > 4"
                class="slt-dark-slider-mask"
                @click="slideToNext"
            >
                <img
                    class="absolute top-[50%] hidden w-[40px] -translate-y-1/2 scale-x-[0.5] scale-y-[2] lg:block"
                    src="@/assets/images/pages/gplay/swipe-arrow.png"
                    alt=""
                />
            </div>
        </div>

        <div v-if="!isScroll" class="video-list-container relative">
            <div
                class="video-list-wrapper w-full px-[4.07vw] xs:px-[16px] sm:px-[5.21vw] lg:px-[5.95vw] 3xl:px-[114.3px]"
            >
                <div
                    class="grid grid-cols-2 gap-x-[4.07vw] gap-y-[8.14vw] xs:gap-x-[16px] xs:gap-y-[32px] sm:grid-cols-3 sm:gap-x-[3.125vw] sm:gap-y-[6.25vw] lg:grid-cols-4 lg:gap-x-[1.59vw] lg:gap-y-[3.18vw] 3xl:gap-x-[30.5px] 3xl:gap-y-[61px]"
                >
                    <template v-for="(video, i) in videos" :key="i">
                        <NuxtLink
                            :to="$localePath(`/gplay/${video.id}`)"
                            class="slt-video-item flex flex-col"
                            @mouseenter="loadVideo(`grid-${i}`)"
                            @mouseleave="pauseVideo(`grid-${i}`)"
                            @click="handleOpenVideo(`grid-${i}`)"
                            v-sendGAsignal="{
                                event_category: 'gplay',
                                event_label: `${video?.id}-${video?.videoTitle}`,
                            }"
                        >
                            <div
                                class="relative aspect-[310/408] w-full overflow-hidden rounded-[4.07vw] xs:rounded-[16px]"
                            >
                                <img
                                    class="relative h-full w-full object-cover object-center"
                                    :src="
                                        shortMedia?.find(
                                            (item) =>
                                                item?.id ==
                                                video?.featured_media,
                                        )?.source_url
                                    "
                                    :alt="
                                        shortMedia?.find(
                                            (item) =>
                                                item?.id ==
                                                video?.featured_media,
                                        )?.alt_text
                                    "
                                    width="310"
                                    height="408"
                                />
                                <video
                                    v-if="
                                        videoLoadState[`grid-${i}`] && !isOpen
                                    "
                                    class="absolute left-0 top-0 z-10 h-full w-full object-cover object-center opacity-0 transition-opacity duration-300"
                                    :src="video.preview[0]"
                                    muted
                                    loop
                                    width="310"
                                    height="408"
                                    :data-video-id="`grid-${i}`"
                                ></video>
                            </div>
                            <div class="flex flex-col px-[8px]">
                                <h3
                                    class="slt-line-clamp-2 slt-h5-d mt-[3.05vw] text-base-white xs:mt-[12px] sm:mt-[1.56vw] lg:mt-3"
                                    v-html="
                                        highlightText(
                                            video.title,
                                            highlightKeyword,
                                        )
                                    "
                                ></h3>
                                <p
                                    class="slt-line-clamp-2 slt-body-3-d mt-[4px] text-base-grey"
                                    v-html="
                                        highlightText(
                                            video.description,
                                            highlightKeyword,
                                        )
                                    "
                                ></p>
                                <div
                                    class="mt-[4.07vw] flex flex-wrap gap-[4px] xs:mt-[16px] sm:mt-[2.6vw] lg:mt-5"
                                >
                                    <div
                                        v-for="(tag, k) in video.categories"
                                        :key="k"
                                        class="slt-hashtag slt-body-3 text-base-white"
                                    >
                                        <p>
                                            {{ tag }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </NuxtLink>
                        <!-- <div
                            v-if="isShowSloganArray[i] >= 0"
                            class="col-span-2 w-full overflow-hidden rounded-[4.07vw] xs:rounded-[16px] sm:col-span-1"
                        >
                            <ClientOnly>
                                <LottieAnimation
                                    class="aspect-[2200/1035] w-full overflow-hidden rounded-b-[4.07vw] xs:rounded-b-[16px] sm:aspect-[1920/2534]"
                                    :key="`${i}-${isShowSloganArray[i]}`"
                                    :animationData="
                                        width >= 640
                                            ? brandBlockList[
                                                  isShowSloganArray[i] % 6
                                              ].desktop
                                            : brandBlockList[
                                                  isShowSloganArray[i] % 6
                                              ].mobile
                                    "
                                />
                            </ClientOnly>
                        </div> -->
                    </template>
                </div>
            </div>
        </div>

        <div
            v-if="showLoadMore && !isScroll"
            ref="loaderRef"
            class="my-[12.21vw] xs:my-[48px] sm:my-[120px] lg:my-40"
        >
            <div
                v-if="isLoading || hasMore"
                class="flex justify-center pt-[4.07vw] xs:pt-[16px] sm:pt-0"
            >
                <div
                    class="slt-bouncing w-[5.09vw] xs:w-[20px] sm:w-[40px] lg:w-[60px]"
                >
                    <GamaGlobeLottie />
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.slt-video-list {
    @apply flex flex-col;
}

.video-list-container {
    @apply relative;
}

.slt-dark-slider-mask {
    @apply z-[5] cursor-pointer select-none;
}

.slt-dark-slider-mask img {
    @apply hidden lg:block;
}

.video-list-container .slt-dark-slider-mask:first-child {
    @apply left-0 lg:origin-left lg:scale-x-[4];
}

.video-list-container .slt-dark-slider-mask:last-child {
    @apply right-0 -translate-x-[150%] scale-x-[-4];
}

.slt-hashtag {
    @apply flex h-[6.36vw] items-center justify-center rounded-[999px] bg-base-dimGrey px-[3.05vw] font-normal xs:h-[25px] xs:px-[12px] lg:h-[1.72vw] lg:px-[0.79vw] lg:pt-[2px] 3xl:h-[33px] 3xl:px-[15.2px];
}

.slt-dark-slider-mask {
    @apply absolute top-0 h-full w-[5.09vw] bg-[linear-gradient(270deg,rgba(0,0,0,0)_0%,#000_100%)] xs:w-[20px];
}
</style>
